<template>
  <div class="user-select">
    <el-form-item label="可查看用户设置">
      <el-radio-group v-model="viewUserType" @change="handleViewTypeChange">
        <el-radio label="all">所有人</el-radio>
        <el-radio label="partner">合伙人</el-radio>
        <el-radio label="today_new">当日新会员</el-radio>
        <el-radio label="days_new">几日内注册会员</el-radio>
        <el-radio label="sign_times">签到满N次会员</el-radio>
        <el-radio label="specific">指定用户</el-radio>
      </el-radio-group>

      <!-- 几日内注册输入框 -->
      <el-input
        v-if="viewUserType === 'days_new'"
        v-model="days"
        size="small"
        placeholder="输入天数"
        style="width: 120px; margin-left: 10px;"
        type="number"
        min="1"
      ></el-input>
      
      <!-- 签到次数输入框 -->
      <el-input
        v-if="viewUserType === 'sign_times'"
        v-model="signTimes"
        size="small"
        placeholder="输入次数"
        style="width: 120px; margin-left: 10px;"
        type="number"
        min="1"
      ></el-input>

      <!-- 指定用户选择按钮 -->
      <el-button 
        v-if="viewUserType === 'specific'"
        type="primary" 
        size="small" 
        @click="showUserDialog"
        style="margin-left: 10px;"
      >
        选择用户
      </el-button>
    </el-form-item>

    <!-- 指定用户显示区域 -->
    <el-form-item v-if="viewUserType === 'specific' && selectedUsers.length > 0" label="已选用户">
      <el-tag
        v-for="user in selectedUsers"
        :key="user.user_id"
        closable
        @close="removeUser(user.user_id)"
        style="margin-right: 5px; margin-bottom: 5px;"
      >
        {{ user.nickName }} (ID: {{ user.user_id }})
      </el-tag>
    </el-form-item>

    <!-- 用户选择对话框 -->
    <el-dialog title="选择用户" :visible.sync="userDialogVisible" width="70%">
      <div class="filter-container">
        <el-input
          v-model="userSearch"
          placeholder="搜索用户ID、昵称或手机号"
          style="width: 200px; margin-right: 10px;"
          clearable
        ></el-input>
        
        <el-button type="primary" @click="getUserList">搜索</el-button>
      </div>
      
      <el-table
        ref="userTable"
        :data="userList"
        border
        style="width: 100%; margin-top: 15px;"
        @selection-change="handleUserSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
        <el-table-column prop="nickName" label="昵称" width="120"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
        <el-table-column prop="grade.name" label="会员等级"></el-table-column>
        <el-table-column prop="create_time" label="注册时间" width="150"></el-table-column>
      </el-table>
      
      <div class="pagination" style="margin-top: 15px;">
        <el-pagination
          @size-change="handleUserSizeChange"
          @current-change="handleUserCurrentChange"
          :current-page="userCurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="userPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="userTotal"
        ></el-pagination>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="userDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmUserSelection">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';

export default {
  data() {
    return {
      viewUserType: 'all', // 查看用户类型
      days: 7,            // 几日内注册，默认7天
      signTimes: 5,       // 签到次数，默认5次
      
      // 用户选择对话框相关
      userDialogVisible: false,
      userSearch: '',
      userList: [],
      userCurrentPage: 1,
      userPageSize: 10,
      userTotal: 0,
      selectedUsers: [],
      tempSelectedUsers: []
    };
  },
  inject: ['form'],
  created() {
    // 初始化设置
    if (this.form.model.view_user_setting) {
      const setting = JSON.parse(this.form.model.view_user_setting);
      this.viewUserType = setting.type || 'all';
      this.days = setting.days || 7;
      this.signTimes = setting.sign_times || 5;
      
      if (setting.type === 'specific' && setting.user_ids) {
        this.selectedUsers = setting.user_ids.map(id => ({ user_id: id }));
      }
    }
  },
  methods: {
    // 处理查看类型变化
    handleViewTypeChange() {
      this.updateViewUserSetting();
    },
    
    // 更新查看用户设置
    updateViewUserSetting() {
      const setting = {
        type: this.viewUserType
      };
      
      if (this.viewUserType === 'days_new') {
        setting.days = this.days;
      } else if (this.viewUserType === 'sign_times') {
        setting.sign_times = this.signTimes;
      } else if (this.viewUserType === 'specific') {
        setting.user_ids = this.selectedUsers.map(user => user.user_id);
      }
      
      this.form.model.view_user_setting = JSON.stringify(setting);
    },
    
    // 用户选择对话框相关方法
    showUserDialog() {
      this.userDialogVisible = true;
      this.getUserList();
    },
    
    getUserList() {
      const params = {
        page: this.userCurrentPage,
        list_rows: this.userPageSize,
        search: this.userSearch
      };
      
      UserApi.userlist(params, true)
        .then(data => {
          this.userList = data.data.list.data;
          this.userTotal = data.data.list.total;
          
          // 设置已选中的用户
          if (this.selectedUsers.length > 0) {
            this.$nextTick(() => {
              this.userList.forEach(user => {
                if (this.selectedUsers.some(u => u.user_id === user.user_id)) {
                  this.$refs.userTable.toggleRowSelection(user, true);
                }
              });
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    
    handleUserSelectionChange(selection) {
      this.tempSelectedUsers = selection;
    },
    
    handleUserSizeChange(val) {
      this.userPageSize = val;
      this.getUserList();
    },
    
    handleUserCurrentChange(val) {
      this.userCurrentPage = val;
      this.getUserList();
    },
    
    confirmUserSelection() {
      this.selectedUsers = JSON.parse(JSON.stringify(this.tempSelectedUsers));
      this.updateViewUserSetting();
      this.userDialogVisible = false;
    },
    
    removeUser(userId) {
      this.selectedUsers = this.selectedUsers.filter(user => user.user_id !== userId);
      this.updateViewUserSetting();
    }
  },
  watch: {
    days(newVal) {
      if (this.viewUserType === 'days_new') {
        this.updateViewUserSetting();
      }
    },
    signTimes(newVal) {
      if (this.viewUserType === 'sign_times') {
        this.updateViewUserSetting();
      }
    }
  }
};
</script>

<style scoped>
.user-select {
  padding: 20px;
}
.filter-container {
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/product/product/part/User.vue